import assetAdvancedFilters from '../modals/advancedFilters/lan/es';
import createEditAsset from '../modals/createEditAsset/lan/es';
import deleteAsset from '../modals/deleteAsset/lan/es';
import importAssets from '../modals/importAssets/lan/es';

export default {
    manage_asset_id: "ID de Activo",
    manage_asset_unit: "Unidad",
    manage_asset_assetType: "Tipo de activo",
    manage_asset_assetSubType: "Subtipo de activo",
    manage_asset_externalID: "ID externo",
    manage_asset_make: "Marca",
    manage_asset_model: "Modelo",
    manage_asset_year: "Año",
    manage_asset_engine: "Motor",
    manage_asset_mpg_highway: "MPG en carretera",
    manage_asset_mpg_city: "MPG en ciudad",
    manage_asset_license_plate: "Matrícula",
    manage_asset_vin: "VIN",
    manage_asset_label: "Etiqueta",
    manage_asset_inspectionDeviceType: "Dispositivo de inspección",
    manage_asset_tags: "Etiquetas",
    manage_asset_status: "Estado",
    manage_asset_active: "Activo",
    manage_asset_inactive: "Inactivo",
    manage_asset_search_table: "Búsqueda por etiqueta, VIN, tipo de activo y subtipo de activo",
    manage_asset_inspectionTagId: "ID de etiqueta de inspección",
    manage_asset_powerUnitNumber: "Número de unidad de potencia",
    manage_asset_maintenanceCompany: "Compañía de mantenimiento",
    manage_asset_registrationCountry: "País de registro",
    manage_asset_registrationState: "Estado de registro",
    manage_asset_registrationExpiration: "Expiración de registro",
    manage_asset_engineSerialNumber: "Número de serie del motor",
    manage_asset_chassisSerialNumber: "Número de serie del chasis",
    manage_asset_licensePlate: "Matrícula",
    ...assetAdvancedFilters,
    ...createEditAsset,
    ...deleteAsset,
    ...importAssets,
}